export const obterPrimeiroEUltimoNome = (nomeCompleto: string) => {
  const nomeSeparado = nomeCompleto.replace('_CONTR', '').split(' ') || []
  const primeiroNome = nomeSeparado.slice(0, 1).join('')
  const ultimoNome = nomeSeparado.slice(-1).join('')

  if (primeiroNome === ultimoNome) return primeiroNome

  return `${primeiroNome} ${ultimoNome}`
}

export const obterIniciaisDoNome = (nomeCompleto: string) => {
  const [primeiroNome, ultimoNome] =
    obterPrimeiroEUltimoNome(nomeCompleto).split(' ')
  const iniciaisDoNome = primeiroNome?.slice(0, 1) + ultimoNome?.slice(0, 1)
  return iniciaisDoNome.toUpperCase()
}

export const obterCodPlataformaFormatado = (codPlataforma: string) => {
  return codPlataforma.replaceAll('_', ' ')
}

export const removerAcentos = (str: string) => {
  return str === '' ? str : str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
